import {
  Box,
  Button,
  Dialog,
  Stack,
  TextField,
  Typography,
  Zoom,
} from "@mui/material";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import AdminPass from "./Notification/AdminPass";
import { blue } from "@mui/material/colors";
import DefaultSMS from "./DefaultSMS";

function Settings(props) {

  const setMainBody = props.setMainBody
  const [openPasswordRequest, setOpenPasswordRequest] = useState(false);
  const [show, setShow] = useState(false);
  
  console.log(setMainBody);
  

  //formik
  const formikForm = useFormik({
    initialValues: {
      partnerID: "",
      senderID: "",
      APIKey: "",
    },
    validationSchema: Yup.object({
      partnerID: Yup.string()
        .required("Required")
        .min(3, "must be more than 3 characters"),
      senderID: Yup.string()
        .required("Required")
        .max(11, "must be less than 12 characters"),
      APIKey: Yup.string()
        .required("Required")
        .min(8, "must be more than 8 characters"),
    }),
    onSubmit: (values) => {
      upDate()
      
    },
  });
  
async function upDate (){
    const response = await fetch("http://127.0.0.1:8000/messenger/setConfigs/", {
      mode: "cors",
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: new URLSearchParams(formikForm.values),
    });
    if(response.body!=null){
    const fetcher = response.body.getReader();
    let data = [];
    let receivedLength = 0;
    while (true) {
      const { value, done } = await fetcher.read();

      if (done) {
        break;
      }

      data.push(value);
      receivedLength += value.length;
    }
    let chunksAll = new Uint8Array(receivedLength);
    let position = 0;
    for (let chunk of data) {
      chunksAll.set(chunk, position);
      position += chunk.length;
    }
    let result = new TextDecoder("utf-8").decode(chunksAll);
    try{
      let finalData = JSON.parse(result); 
    }
    catch {
      console.log('Error');
      
    }
      
    }
  }

  const handleUpdateClick = ()=>{
    setOpenPasswordRequest(true)
  }

  return (
    <Zoom in={true} style={{ transitionDelay: "200ms" }}>
    <Stack>
      <Button
        onClick={() => {
          setShow(!show);
        }}
        fullWidth
        variant="outlined"
      >
        Change sms settings
      </Button>
      <Box display={show ? "flex" : "none"}>
        <form onSubmit={formikForm.handleSubmit}>
          <Stack rowGap={2} mt={2} bgcolor={blue[50]} padding={2} borderRadius={5}>
            <Stack display={"flex"} width={'50vw'} >
              <TextField
                size="small"
                type="password"
                label="Partner ID"
                id="partnerID"
                name="partnerID"
                value={formikForm.values.partnerID}
                onChange={formikForm.handleChange}
                fullWidth
              />
              {formikForm.touched.partnerID && formikForm.errors.partnerID ? (
                <Typography color="error">
                  {formikForm.errors.partnerID}
                </Typography>
              ) : null}
            </Stack>
            <Stack display={"flex"}>
              <TextField
                size="small"
                label="Sender ID"
                id="senderID"
                name="senderID"
                value={formikForm.values.senderID}
                onChange={formikForm.handleChange}
                fullWidth
              />
              {formikForm.touched.senderID && formikForm.errors.senderID ? (
                <Typography color="error">
                  {formikForm.errors.senderID}
                </Typography>
              ) : null}
            </Stack>
            <Stack display={"flex"}>
              <TextField
                size="small"
                label="API Key"
                type="password"
                id="APIKey"
                name="APIKey"
                value={formikForm.values.APIKey}
                onChange={formikForm.handleChange}
                fullWidth
              />
              {formikForm.touched.APIKey && formikForm.errors.APIKey ? (
                <Typography color="error">
                  {formikForm.errors.APIKey}
                </Typography>
              ) : null}
            </Stack>
            <Box display={"flex"} justifyContent={"center"}>
              <Button variant="outlined" onClick={handleUpdateClick} >
                Update
              </Button>
            </Box>
          </Stack>
        </form>
      </Box>
      <Stack display={"flex"} justifyContent={"center"} my={1} rowGap={2}>
        <Button variant="outlined">View SMS Balance</Button>
        <Button variant="outlined" onClick={()=>setMainBody(<DefaultSMS />)}>Default sms</Button>
      </Stack>
      <Dialog
        open={openPasswordRequest}
        onClose={() => setOpenPasswordRequest(false)}
      >
        <AdminPass open={setOpenPasswordRequest} submitForm={formikForm.handleSubmit} />
      </Dialog>
    </Stack>
    </Zoom>
  );
}

export default Settings;
